export enum USER_ACTION_TYPES {
  FETCH_LOGGED_USER = 'FETCH_LOGGED_USER',
}
